import { call, delay } from 'redux-saga/effects';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, import/prefer-default-export
export function* retryIf<Fn extends (...args: any[]) => any>(
  maxTries: number,
  delayLength: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  retryCondition: (e: any) => boolean,
  fn: Fn,
  ...args: Parameters<Fn>
) {
  let remainingTries = maxTries;

  while (true) {
    try {
      remainingTries -= 1;
      const result: Awaited<ReturnType<typeof fn>> = yield call(fn, ...args);
      return result;
    } catch (e) {
      if (retryCondition(e) && remainingTries > 0) {
        yield delay(delayLength);
      } else {
        throw e;
      }
    }
  }
}
